import { SIZE_200_MB } from './uploads';

export const CHANGE_USER_EMAILS_MAX_NUMBER_OF_FILES: number = 1;
export const CHANGE_USER_EMAILS_MAX_FILE_SIZE: number = SIZE_200_MB;
